import { navigate } from '../utils/router.js';
import { applyTheme, getTheme } from '../utils/theme.js';
import { initLandingSphere } from './landing-sphere.js';

/**
 * Landing: Earth Ultra scroll-sphere experience + GSORG story copy.
 */
export function renderLanding(root) {
  const prevTheme = getTheme();
  document.documentElement.setAttribute('data-theme', 'dark');
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', '#0a1628');

  // Prevent app shell scroll styles from fighting the tall stage
  document.documentElement.classList.add('landing-active');
  document.body.classList.add('landing-active');

  root.innerHTML = `
    <div class="landing-root" id="landing-root">
      <canvas class="orb" id="orb" aria-hidden="true"></canvas>
      <div class="vignette" id="vignette" aria-hidden="true"></div>
      <div class="progress" id="progress" aria-hidden="true"></div>

      <button type="button" class="landing-skip" id="landing-skip">跳过 → 登录</button>

      <div class="stage" id="stage" aria-label="全球学校组织滚动体验">
        <div class="overlay" id="overlay">
          <div class="intro" id="intro">
            <h1>
              GlobalSchoolOrganization
              <span class="soft">全球学校组织</span>
            </h1>
            <p class="tagline">由学生创建，为学生服务</p>
            <p class="hint">Scroll <span class="ar">↓</span></p>
          </div>

          <span class="beacon-tag" data-i="0"><span class="num">01</span> 起源</span>
          <span class="beacon-tag" data-i="1"><span class="num">02</span> 轨迹</span>
          <span class="beacon-tag" data-i="2"><span class="num">03</span> 边界</span>

          <article class="panel" data-i="0">
            <span class="pn">01</span>
            <h2>起源之点</h2>
            <p class="kicker">从不起眼的纸条中醒来</p>
            <p>
              成立于 2024.10.17，在西安高新东区初级中学成立。最早只是一张写满班级日志素材的纸条；
              后来我们脱离班级日志，自己创办了晚报，按班级名称命名为 G7 晚报，运营主体为 G7 组织，缩写 GSORG。
              每个人都可以在上面写下自己的话语，大家积极参与，逐渐演变为了全球学校组织。
            </p>
          </article>

          <article class="panel" data-i="1">
            <span class="pn">02</span>
            <h2>轨迹之线</h2>
            <p class="kicker">五百天沧桑</p>
            <p>
              我们创办了 7 册报纸，承载满满的回忆，并开始开办网站。2025.10.17 举办 G7 晚报一周年纪念日，
              期间晚报与组织达到鼎盛，晓谕半校，一度成为年级最大学生媒体。为国际化接轨，我们将 GSORG
              从「G7 组织」更名为「全球学校组织」。直至 2026.3.12，寒假开学后迫于中考压力，流量急剧下降，
              我们宣布 2026 届 G7 晚报彻底停业。
            </p>
          </article>

          <article class="panel" data-i="2">
            <span class="pn">03</span>
            <h2>边界之外</h2>
            <p class="kicker">晚报虽停，情谊永驻，不断扩散</p>
            <p>
              2026.3.13，我们将晚报全权交接给 2027 届同学们，希望他们能把晚报发扬光大。
              同时立项开发本「全球学校组织」项目，践行初心：由学生创建，为学生服务。
            </p>
          </article>

          <div class="stars-msg" id="starsMsg">
            <h2>满天繁星</h2>
            <p>
              球体既散，若漫天星辰。原 2026 届 G7 班长存于每个人心间，让我们初心不改，成就明日光辉！
            </p>
            <button type="button" class="enter-btn" id="landing-enter">进入 · 登录 / 注册</button>
          </div>
        </div>
      </div>

      <div class="scroll-end" aria-hidden="true"></div>

      <button type="button" class="auto-scroll-btn" id="autoScrollBtn" aria-pressed="false" aria-label="继续">
        <span class="ic ic-play" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 5v14l11-7z" fill="currentColor" stroke="none"/></svg>
        </span>
        <span class="ic ic-pause" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>
        </span>
        <span class="label-idle">继续</span>
        <span class="label-playing">暂停</span>
      </button>
    </div>
  `;

  const goAuth = () => navigate('/login');
  root.querySelector('#landing-skip')?.addEventListener('click', goAuth);
  root.querySelector('#landing-enter')?.addEventListener('click', goAuth);

  const cleanupSphere = initLandingSphere(root.querySelector('#landing-root') || root);

  return () => {
    cleanupSphere?.();
    document.documentElement.classList.remove('landing-active');
    document.body.classList.remove('landing-active');
    applyTheme(prevTheme);
  };
}
